import { Spinner } from "@components/ui-kit";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import {
  getQueryParamOptional,
  parseActiveQueryParam,
} from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { CardListOutgoingInvoices } from "./CardListOutgoingInvoices";
import { QuickFilters, StoreOutgoingInvoices } from "./StoreOutgoingInvoices";

export const PageOutgoingInvoicesCtx = React.createContext(
  {} as StoreOutgoingInvoices,
);

export const PageOutgoingInvoices = withCan(
  {
    do: [
      "outgoingInvoice_read_all",
      "outgoingInvoice_read_own",
      "outgoingInvoice_read_team",
    ],
  },
  observer(function PageOutgoingInvoices() {
    const { query } = useRouter();

    const [store] = useState(() => {
      const store = StoreOutgoingInvoices.create();
      const active = parseActiveQueryParam(query);
      store.fetchFilterOptions();

      if (active === QuickFilters.InvoiceItems) {
        store.activeQuickFilter = active;
        return store;
      }

      store.setSearchTerm(getQueryParamOptional("search", query) || "");
      store.setQuickFilterFromURL(query);
      store.where.fromURLSearchParam(query);
      store.orderBy.fromURLSearchParam(query);
      store.pagination.fromURLSearchParam(query);
      return store;
    });

    useUpdateURI(store.searchParams, undefined, store.isInvoiceItemsActive);

    return (
      <PageOutgoingInvoicesCtx.Provider value={store}>
        <div className="flex justify-center items-center">
          <div className="w-full">
            {store.isLoading && <Spinner absolute />}
            <CardListOutgoingInvoices />
          </div>
        </div>
      </PageOutgoingInvoicesCtx.Provider>
    );
  }),
);
